/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontSocial_user = {
    readonly serviceId: string | null;
    readonly " $refType": "StorefrontSocial_user";
};
export type StorefrontSocial_user$data = StorefrontSocial_user;
export type StorefrontSocial_user$key = {
    readonly " $data"?: StorefrontSocial_user$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontSocial_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontSocial_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '88b81f8bc399bdcf21454342b168132d';
export default node;
